export const SERVICE_ACTIVE = 'active';
export const SERVICE_DISMISSED = 'dismissed';
